module.exports = __webpack_public_path__ + "img/purchase_vaccine_infographic.5fdceaa2.svg";